import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ChatApiImpl, ChatApi } from './apis';

export const chatContainer = new ContainerModule((bind) => {
    bind(ChatApi).to(ChatApiImpl);
});
